import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import AuthService from '../../../Services/authService';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';

export default class ClientInvoiceSearchParams extends SearchParamsBase {
  initialize() {
    this.CiId = '';
    this.ClientNameOrId = '';
    this.StatusIds = [1];
    this.OfficeIds = OfficeHelper.GetDefaultOfficeIds(ClientInvoiceSearchParams.getUserOffice());
    this.IsUnpaid = '';
    this.IsPastDue = '';
    this.CiYrmo = '';
    this.CiPonumber = '';
    this.CiInvoiceNumber = '';
  }

  static fieldsInSearchBox = [
    { fieldName: 'CiId', label: 'Bare Invoice #', className: 'col-4', type: InputTypesEnum.Number },
    { fieldName: 'ClientNameOrId', label: 'Client Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'StatusIds',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.MultiChoice,
      options: ClientInvoiceSearchParams.getStatusOptions(),
    },
    { fieldName: 'OfficeIds', label: 'Office', className: 'col-4', type: InputTypesEnum.OfficeOrGroupMultiSelect },
    { fieldName: 'IsUnpaid', label: 'Unpaid', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'IsPastDue', label: 'Past Due', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'CiYrmo', label: 'YRMO', className: 'col-4', type: InputTypesEnum.Number },
    { fieldName: 'CiPonumber', label: 'PO #', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'CiInvoiceNumber', label: 'Client Invoice #', className: 'col-4', type: InputTypesEnum.Text },
  ];

  static getUserOffice() {
    const user = AuthService.getInstance().GetLoggedInUser();
    return user.officeId;
  }

  static getStatusOptions() {
    return [
      { label: 'Draft', value: 1 },
      { label: 'Finalized', value: 2 },
      { label: 'Paid', value: 3 },
      { label: 'Cancelled', value: 4 },
    ];
  }

  static iconName = 'fa-solid fa-search';
  static saveType = 'ClientInvoiceSearchParams';
}
